/**
 * Contact_Entity type guard.
 *
 * @param {any} contactJson Contact object from API
 * @returns {boolean} Return true if type is Contact_Entity
 */

export default class Contact_Entity {
  constructor(contactJson: Contact_Entity) {
    this.id = contactJson.id;
    this.memberID = contactJson.memberID;
    this.category = contactJson.category;
    this.label = contactJson.label;
    this.phone = contactJson.phone;
    this.email = contactJson.email;
    this.street = contactJson.street;
    this.city = contactJson.city;
    this.state = contactJson.state;
    this.zipcode = contactJson.zipcode;
    this.country = contactJson.country;
    this.primary = contactJson.primary;
    this.public = contactJson.public;
    this.validated = contactJson.validated;
    this.changed = contactJson.changed;
    this.createdAt = contactJson.createdAt;
    this.updatedAt = contactJson.updatedAt;
  }

  id: number;
  memberID: number;
  category: string;
  label?: string;
  phone?: string;
  email?: string;
  street?: string;
  city?: string;
  state?: string;
  zipcode?: string;
  country?: string;
  primary?: boolean;
  public?: boolean;
  validated?: boolean;
  changed?: boolean;
  createdAt: string;
  updatedAt: string;
}
